// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo-3LvcI1cY"};